import { render, staticRenderFns } from "./roleManager.vue?vue&type=template&id=3721b12b&scoped=true&"
import script from "./roleManager.vue?vue&type=script&lang=js&"
export * from "./roleManager.vue?vue&type=script&lang=js&"
import style0 from "./roleManager.vue?vue&type=style&index=0&id=3721b12b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3721b12b",
  null
  
)

export default component.exports